import React, { useContext } from 'react'
import { LocaleContext } from '../../../../contexts/LocaleContext'
import Modal from '../../../Modal/Modal'

const COPY = {
  en: {
    title: 'Important Check Before Uploading',
    body: 'Is this the final version, including:',
    items: [
      'The advertising disclosure in the caption/description?',
      'Any required text overlays?',
      'Royalty-free or approved music?',
    ],
    warning: 'Otherwise, we will not be able to approve the content. Should you upload the content with music, please make sure that the music is royalty-free.',
    confirm: 'Yes, I Confirm',
  },
  de: {
    title: 'Wichtiger Hinweis vor dem Upload',
    body: 'Ist dies die finale Version deines Entwurfs? Bitte stelle sicher, dass:',
    items: [
      'Die korrekte Werbekennzeichnung in der Caption / Beschreibung enthalten ist.',
      'Alle vertraglich vereinbarten Text-Overlays integriert sind.',
      'Ausschließlich lizenzfreie oder freigegebene Musik verwendet wurde (falls Musik enthalten ist).',
    ],
    warning: 'Solltest du Content mit nicht-lizenzierter Musik hochladen, können wir diesen Entwurf leider nicht freigeben.',
    confirm: 'Ja, ich bestätige',
  },
}

export default function PreUploadConfirmModal({ isOpen, onClose, onConfirm }) {
  const { localeState } = useContext(LocaleContext)
  const copy = COPY[localeState.locale] || COPY.en

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>{copy.title}</Modal.Header>
      <Modal.Body>
        <p className="mb-2 dark:text-white">{copy.body}</p>
        <ul className="list-disc pl-5 mb-3 dark:text-white">
          {copy.items.map(item => <li key={item}>{item}</li>)}
        </ul>
        <p className="text-sm italic dark:text-rb-dark-mode-text-grey">{copy.warning}</p>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={onClose} className="rb-btn-cancel px-4 py-2 text-sm font-medium">Cancel</button>
        <button onClick={onConfirm} className="px-4 py-2 text-sm font-medium text-white bg-rb-green rounded-lg">{copy.confirm}</button>
      </Modal.Footer>
    </Modal>
  )
}
